import { h } from "tsx-dom";
import RedWarnUI from "app/ui/RedWarnUI";

import "../css/pageIcons.css";
import { Injector } from "./Injector";
import classMix from "app/styles/material/util/classMix";
import RedWarnHooks from "app/event/RedWarnHooks";

export default class PageIconsInjector implements Injector {
    /**
     * Initialize the injector. If the page is a diff page, this injector
     * will trigger.
     */
    async init(): Promise<void> {
        const firstHeading = document.getElementById("firstHeading");

        const pageIconsMain = new RedWarnUI.PageIcons();
        const pageIcons = (
            <div
                id={"rwPageIcons"}
                class={classMix(
                    // `true` if not displayed
                    firstHeading.offsetParent == null &&
                        "rw-firstHeading--hidden"
                )}
            >
                {pageIconsMain.render()}
            </div>
        );

        const target =
            document.querySelector(".mw-indicators") ??
            // Fallback to article title.
            firstHeading;
        target.insertAdjacentElement("beforebegin", pageIcons);

        RedWarnHooks.addHook("deinit", () => {
            pageIcons.parentElement?.removeChild(pageIcons);
        });
    }
}
